import service from "./service";

/**
 * getTestCandidates
 * @property {number} taskId
 * @property {array[string]} testStatuses
 */
async function getTestCandidates(payload) {
  try {
    const res = await service.getTestCandidates(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * getTestList
 */
function getTestList(payload) {
  try {
    const res = service.getTestList(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

/**
 * getTestPreparers
 * @property {string} candidateType
 * @property {string} nameKeyword
 * @property {number} projectId
 */
async function getTestPreparers(payload) {
  try {
    const res = await service.getTestPreparers(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * setTestsStatus
 * @property {string} modifiedStatus
 * @property {number|array[string]} testId
 */
async function setTestsStatus(payload) {
  try {
    const res = await service.setTestsStatus(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function getTestInfo(payload) {
  try {
    const res = await service.getTestInfo(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function getTestItemId(payload) {
  try {
    const res = await service.getTestItemId(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function getTestItemInfo(payload) {
  try {
    const res = await service.getTestItemInfo(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function setTestItemStatus(payload) {
  try {
    const res = await service.setTestItemStatus(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function setSaveTestItem(payload) {
  try {
    const res = await service.setSaveTestItem(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function getTestItems(payload) {
  try {
    const res = await service.getTestItems(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function getTestPageInfo(payload) {
  try {
    const res = await service.getTestPageInfo(payload);
    return res;
  } catch (error) {
    return null;
  }
}
async function getTestSubmitters(payload) {
  try {
    const res = await service.getTestSubmitters(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function getTestProgress(payload) {
  try {
    const res = await service.getTestProgress(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function getTestNextSubmitter(payload) {
  try {
    const res = await service.getTestNextSubmitter(payload);
    return res;
  } catch (error) {
    return null;
  }
}

export default {
  getTestCandidates,
  getTestList,
  getTestPreparers,
  setTestsStatus,
  getTestInfo,
  getTestItemId,
  getTestItemInfo,
  setTestItemStatus,
  setSaveTestItem,
  getTestItems,
  getTestPageInfo,
  getTestSubmitters,
  getTestProgress,
  getTestNextSubmitter,
};
